(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaTransfReceptionLine', PharmaTransfReceptionLine);

	PharmaTransfReceptionLine.$inject = [ '$resource' ];

	function PharmaTransfReceptionLine($resource) {
		var resourceUrl = 'api/pharma-transf-reception-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
